// src/components/ImportTasks.js
import React from 'react';
import { useNavigate } from 'react-router-dom';
import TaskUploadForm from './TaskUploadForm';
import { FaArrowLeft } from 'react-icons/fa';

const ImportTasks = () => {
    const navigate = useNavigate();

    return (
        <div className="import-tasks-container">
            <div className="import-header">
                <button className="back-button" onClick={() => navigate(-1)}>
                    <FaArrowLeft /> Back
                </button>
                <h1>Import Tasks</h1>
            </div>

            <div className="import-content">
                <TaskUploadForm />
            </div>

            <style jsx>{`
                .import-tasks-container {
                    max-width: 1000px;
                    margin: 0 auto;
                    padding: 20px;
                }

                .import-header {
                    display: flex;
                    align-items: center;
                    gap: 20px;
                    margin-bottom: 30px;
                }

                .back-button {
                    display: flex;
                    align-items: center;
                    gap: 8px;
                    background: #6c757d;
                    color: white;
                    border: none;
                    padding: 10px 20px;
                    border-radius: 6px;
                    cursor: pointer;
                }

                .import-content {
                    background: white;
                    border-radius: 12px;
                    padding: 30px;
                    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
                }
            `}</style>
        </div>
    );
};

export default ImportTasks;